import React from 'react';
import Signup from './Signup';
import withRoot from '../withRoot';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  signupUiForBooks: {
  },
});



class Index extends React.Component {
  render() {
    return (
      <div className="signupUiForBooks">
        <Signup></Signup>
      </div>
    )
  }
}


export default withRoot(withStyles(styles)(Index));
